// Filter
import Shuffle from "shufflejs";

class Demo {
  constructor(element) {
    this.element = element;
    this.shuffle = new Shuffle(element, {
      itemSelector: ".portfolio-grid__item",
    });

    this.addShuffleEventListeners();
    this.addFilterButtons();
  }

  addShuffleEventListeners() {
    this.shuffle.on(Shuffle.EventType.LAYOUT, () => {});
    this.shuffle.on(Shuffle.EventType.REMOVED, () => {});
  }

  addFilterButtons() {
    const options = document.querySelector(".filters-button-group");
    if (!options) {
      return;
    }

    const filterButtons = Array.from(options.children);
    const onClick = this._handleFilterClick.bind(this);
    filterButtons.forEach((button) => {
      button.addEventListener("click", onClick, false);
    });
  }

  _handleFilterClick(evt) {
    const btn = evt.currentTarget;
    const isActive = btn.classList.contains("is-checked");
    const isShow = btn.classList.contains("show-btn");
    const btnGroup = btn.getAttribute("data-group");

    this._removeActiveClassFromChildren(btn.parentNode);

    let filterGroup;
    if (isActive) {
      btn.classList.remove("is-checked");
      filterGroup = Shuffle.ALL_ITEMS;
    } else {
      btn.classList.add("is-checked");
      filterGroup = btnGroup;
    }

    if (isShow) {
      btn.classList.add("is-checked");
      filterGroup = Shuffle.ALL_ITEMS;
    } else {
      btn.classList.add("is-checked");
      filterGroup = btnGroup;
    }
    this.shuffle.filter(filterGroup);
    const itemVisible = document.querySelectorAll(".portfolio-grid__item");
    if (itemVisible.length) {
      const elementShow = [];
      itemVisible.forEach((element) => {
        element.classList.remove("is-odd", "is-even", "second-child");
        if (element.className.includes("shuffle-item--visible")) {
          this.shuffle.filter(filterGroup);
          elementShow.push(element);
          if (elementShow.length === 2) {
            element.classList.add("second-child");
          } else {
            element.classList.remove("second-child");
          }
          if (elementShow.length % 2 === 0) {
            element.classList.add("is-even");
          } else {
            element.classList.add("is-odd");
          }
        }
      });
    }
  }

  _removeActiveClassFromChildren(parent) {
    const { children } = parent;
    for (let i = children.length - 1; i >= 0; i--) {
      children[i].classList.remove("is-checked");
    }
  }
}

let portfolioDropdownAbort = null;
let portfolioClickHandlerRegistered = false;

const registerPortfolioClickHandler = () => {
  if (portfolioClickHandlerRegistered) {
    return;
  }
  portfolioClickHandlerRegistered = true;

  document.addEventListener("click", (event) => {
    const portfolioLength = document.querySelector(".portfolio-cate-wrap");
    if (!portfolioLength) {
      return;
    }

    if (
      event.target.className.includes("portfolio__item") ||
      event.target.className.includes("link")
    ) {
      event.preventDefault();
      const categoryTitle = portfolioLength
        .closest(".portfolio-cate-wrap")
        ?.querySelector(".portfolioheader__titletext");
      if (categoryTitle) {
        categoryTitle.innerHTML = event.target.innerHTML;
      }
      event.target.closest(".portfolio--categories")?.classList.remove("d-block");
    }
  });
};

export const initPortfolioFilter = () => {
  registerPortfolioClickHandler();

  document.querySelectorAll(".portfolio-grid").forEach((element) => {
    if (element.__portfolioFilter) {
      element.__portfolioFilter.shuffle?.destroy();
    }
    element.__portfolioFilter = new Demo(element);
  });

  if (portfolioDropdownAbort) {
    portfolioDropdownAbort.abort();
  }
  portfolioDropdownAbort = new AbortController();
  const { signal } = portfolioDropdownAbort;

  const categoryHeader = document.querySelector(".portfolioheader--categories");
  const categoryList = document.querySelector(".portfolio--categories");

  if (!categoryHeader || !categoryList) {
    return;
  }

  categoryHeader.addEventListener(
    "click",
    () => {
      categoryHeader.classList.toggle("portfolioheader--open");
      categoryList.classList.toggle("d-block");
    },
    { signal }
  );
};

if (document.querySelectorAll(".portfolio-grid").length) {
  initPortfolioFilter();
}
